import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col bg-ivory text-ink">
            <Navbar />
            <main className="flex-1 pt-20 md:pt-24">{children}</main>
            <Footer />
        </div>
    );
};

export default Layout;
